<div [formGroup]="formGroup" class="tw-flex tw-flex-col tw-gap-y-6 tw-w-full">
  <div class="tw-flex tw-gap-x-4 tw-min-h-[500px]">
    <div class="tw-flex tw-flex-col tw-gap-y-6 tw-w-[330px] tw-h-full">
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        class="tw-w-[330px]"
      >
        <mat-label>出発地</mat-label>
        <input
          matInput
          formControlName="startLocationId"
          [matAutocomplete]="startLocationAutocomplete"
          name="startLocationId"
        />
        <mat-autocomplete
          #startLocationAutocomplete="matAutocomplete"
          [displayWith]="displayStartLocationName"
          (optionSelected)="onStartLocationSelected($event.option.value)"
        >
          @for (location of filteredStartLocationList | async; track
          location.locationId) {
            <mat-option [value]="location.locationId">
              {{ location.locationName }}
            </mat-option>
          }
        </mat-autocomplete>
        <mat-icon matSuffix>arrow_drop_down</mat-icon>
        <mat-error
          *ngIf="formGroup.controls['startLocationId'].errors?.['required']"
        >
          出発地を選択してください。
        </mat-error>
        <mat-error
          *ngIf="
            formGroup.controls['startLocationId'].errors?.[
              'invalidLocationSelection'
            ]
          "
        >
          出発地は候補から選択してください。
        </mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        floatLabel="always"
        class="tw-w-[330px]"
      >
        <mat-label>到着地</mat-label>
        <input
          matInput
          formControlName="arrivalLocationId"
          [matAutocomplete]="arrivalLocationAutocomplete"
          name="arrivalLocationId"
        />
        <mat-autocomplete
          #arrivalLocationAutocomplete="matAutocomplete"
          [displayWith]="displayArrivalLocationName"
          (optionSelected)="onArrivalLocationSelected($event.option.value)"
        >
          @for (location of filteredArrivalLocationList | async; track
          location.locationId) {
            <mat-option [value]="location.locationId">
              {{ location.locationName }}
            </mat-option>
          }
        </mat-autocomplete>
        <mat-icon matSuffix>arrow_drop_down</mat-icon>
        <mat-error
          *ngIf="formGroup.controls['arrivalLocationId'].errors?.['required']"
        >
          到着地を選択してください。
        </mat-error>
        <mat-error
          *ngIf="
            formGroup.controls['arrivalLocationId'].errors?.[
              'invalidLocationSelection'
            ]
          "
        >
          到着地は候補から選択してください。
        </mat-error>
      </mat-form-field>
    </div>

    <div class="tw-w-full tw-min-h-full tw-h-[500px] tw-min-w-[600px]">
      <app-shipment-route-map
        class="tw-w-full tw-min-h-full tw-max-h-full"
        [route]="selectedRoute"
        [displayButtonOnPopup]="!this.formGroup.disabled"
        [numberOfViaLocationForm]="0"
        (startLocationUpsert)="upsertStartLocation($event)"
        (arrivalLocationUpsert)="upsertArrivalLocation($event)"
        mapId="dialog-map"
      ></app-shipment-route-map>
    </div>
  </div>
</div>
